// domain/garansi — masa garansi (preset → hari) + status. Murni. Port prototype.
const PRESET_DAYS: Record<string, number> = {
  'Tidak Ada': 0, '3 Hari': 3, '7 Hari': 7, '14 Hari': 14, '30 Hari': 30,
  '1 Bulan': 30, '2 Bulan': 60, '3 Bulan': 90, '6 Bulan': 180, '1 Tahun': 365, 'Lifetime': 36500,
};
export const garansiDays = (g: string | null | undefined): number => PRESET_DAYS[g ?? ''] ?? 0;

export interface GaransiStatus { txt: string; sisa: number; aktif: boolean; }

export function garansiStatus(garansi: string | null | undefined, base: string | null | undefined): GaransiStatus {
  const days = garansiDays(garansi);
  if (!days) return { txt: 'Tidak ada', sisa: 0, aktif: false };
  if (days >= 36500) return { txt: 'Lifetime', sisa: 36500, aktif: true };
  if (!base) return { txt: garansi ?? '-', sisa: days, aktif: true };
  const sisa = Math.ceil((new Date(base).getTime() + days * 86400000 - Date.now()) / 86400000);
  return sisa >= 0 ? { txt: `Sisa ${sisa} hari`, sisa, aktif: true } : { txt: 'Lewat garansi', sisa, aktif: false };
}

/** Garansi habis / tidak ada → servis-lagi jadi tiket baru berbayar. */
export const garansiExpired = (garansi: string | null | undefined, base: string | null | undefined): boolean =>
  !garansiStatus(garansi, base).aktif;
